<template>
  <el-form
    :model="form"
    ref="form">
    <el-form-item
      :label="L10n('score-index')"
      prop="scoreIndex"
      :rules="getValidationRule('required,number')"
      class="material-style">
      <el-input
        ref="firstField"
        v-model.number="form.scoreIndex"
        @change="updateModelItem('scoreIndex', { required: true })"/>
    </el-form-item>
    <el-form-item
      :label="L10n('score-text')"
      prop="scoreText"
      :rules="getValidationRule('required,minLength')"
      class="material-style">
      <el-input
        ref="secondField"
        :value="form.scoreText"
        @input="form.scoreText = valueTrimLeft($event)"
        @change="updateModelItem('scoreText', { required: true })"/>
    </el-form-item>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormScores',
  mixins: [Form]
}
</script>
